export const productAdditionalFields = [
  'color',
];
export default `
  #graphql
  fragment ProductAdditionalFields on ProductInterface {
    ${productAdditionalFields.join('\n')}
  }
`;
